var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard"},[_c('WizardProgress',{attrs:{"steps":_vm.steps,"current-step":_vm.currentStep}}),_vm._t("default",null,{"currentStep":_vm.currentStep})],2)}
var staticRenderFns = []

export { render, staticRenderFns }